import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SearchSettings.css';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import SearchSettingsForm from '../../../components/siteadmin/SearchSettingsForm';
import Loader from '../../../components/Loader';

class SearchSettings extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getSearchSettings: PropTypes.object,
    })
  };  

  static defaultProps = {
    data: {
      loading: true
    }
  };

  render () {
    const { data: { loading, getSearchSettings } } = this.props;
    if(loading){
      return <Loader type={"text"} />;
    } else {
      return <SearchSettingsForm initialValues={getSearchSettings} />
    }
  }
}

export default compose(
    withStyles(s),
    withQuery(gql `
        {
          getSearchSettings{
            id
            minPrice
            maxPrice
            priceRangeCurrency
          }
        }
      `,
      {
        options: {
          fetchPolicy: 'network-only',
          ssr: false
        }
      }    
    ),
)(SearchSettings);
